const tours_detail = [
    {
        title: 'Skardu & Shigar Valley',
        sub_title: 'Destination',
        details: 'Pakistan, particularly the northern region is known in the world' + ' for its gorgeous floras and the meadows enveloped with the blooming' + ' flowers. The Baltistan locale changes its landscapes with each season,' + ' and one can experience the four seasons here and in every period the excellence' + ' of this region is distinct and engaging. Indeed, an enormous number of tourists' + ' from around the globe visit this place yearly to capture the colors of blossom.' + ' Pakistan is home to numerous wonders and landscapes like the world\'s highest' + ' mountains, lakes and other. Deosai Plateau is one of them which is the world\'s' + ' second highest plateau and its wonderful scenes are similarly engaging. Deosai' + ' Plateau is situated at an average elevation of 4,114 m above sea level. Deosai' + ' literally means \'the land of Giants\' in Urdu. To sum it all up, this visit would' + ' be an ideal open door for those who might truly love to see the excellence of Pakistan at its pinnacle. ',
        duration_d_n: ' 7 Days - 6 Nights',
        duration_d: ' 7 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-skardu-cover.png',
        other_images: ['/images/tour_card/skardu1.png', '/images/tour_card/skardu2.png'],
        availability: 'October - November',
        pickup: 'Islamabad Airport',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['All transportation in destination location', '6 Nights Hotel Accommodation on sharing basis', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Islamabad - Chilas',
            description: ['Pickup from airport and departure from Islamabad', 'Departure for Chilas via Abbottabad, Mansehra onward over Karakorum Highway.', 'Lunch will be served at Local Restaurant.', 'Arrived at the hotel in Chilas.', 'Dinner & overnight stay at hotel in Chilas. (Lunch & Dinner)']
        }, {
            arrow: 'Two',
            title: 'Chilas - Skardu',
            description: ['Breakfast at hotel.', 'After Breakfast drive to Skardu.', 'On the way to the destination we will stop at the meeting point of 3 greatest mountain ranges and viewpoint of Nanga Parbat.', 'Lunch will be served at a local restaurant.', 'Arrived and transfer to the hotel Skardu.', 'Dinner and overnight stay at the hotel. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Three',
            title: 'Skardu',
            description: ['Deosai Plains Excursion', 'Breakfast at Hotel', 'After Breakfast full day excursion to Satpara Lake & Deosai Plains.', 'Get your pack lunch from your hotel in Skardu.', 'Drive back to Hotel.', 'Dinner and overnight stay at hotel in Skardu. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Four',
            title: 'Skardu - Khaplu',
            description: ['Breakfast at Hotel', 'After breakfast proceed for a full day excursion to Khaplu Fort.', 'Hot lunch will be served at local restaurant.', 'Visit local areas Khaplu Fort, Old Chaqchan Mosque.', 'Dinner and Overnight Stay at hotel in Khaplu. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Five',
            title: 'Khaplu - Shigar - Skardu',
            description: ['Breakfast at Hotel', 'After breakfast drive back to Shigar.', 'On the way visit Manthokha waterfall.', 'Hot lunch will be served at a local restaurant.', 'Visit local areas Shigar Fort, Old Amburiq Mosque.', 'Dinner and Overnight Stay at the hotel in Skardu. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Six',
            title: 'Skardu - Chilas',
            description: ['Breakfast at Hotel.', 'Drive back to Chilas.', 'Lunch will be served at Local Restaurant.', 'Upon arrival transfer to the hotel in Chilas.', ',Dinner and overnight Stay at hotel. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Seven',
            title: 'Chilas - Islamabad',
            description: ['Breakfast at Hotel.', 'After breakfast departure for Islamabad.', 'On the way lunch will be provided at local restaurant.', 'Reached Islamabad.', 'After farewell dinner, drop to Airport. (Breakfast, Lunch, Dinner)']
        }],
        gallery: [
            [
                {
                    1: '/images/gallary/skardu/back-skardu-1.jpg', 2: '/images/gallary/skardu/front-skardu-1.png'
                },

                {
                    1: '/images/gallary/skardu/back-skardu-2.jpg', 2: '/images/gallary/skardu/front-skardu-2.png'
                }
            ],
            [
                {
                    1: '/images/gallary/skardu/back-skardu-3.jpg', 2: '/images/gallary/skardu/front-skardu-3.png'
                },
            ],
            [
                {
                    1: '/images/gallary/skardu/back-skardu-4.jpeg', 2: '/images/gallary/skardu/front-skardu-4.png'
                },

                {
                    1: '/images/gallary/skardu/back-skardu-5.jpeg', 2: '/images/gallary/skardu/front-skardu-5.png'
                }
            ],
            [
                {
                    1: '/images/gallary/skardu/back-skardu-6.JPG', 2: '/images/gallary/skardu/front-skardu-6.png'
                },
            ],
            [
                {
                    1: '/images/gallary/skardu/back-skardu-7.JPG', 2: '/images/gallary/skardu/front-skardu-7.png'
                },

                {
                    1: '/images/gallary/skardu/back-skardu-8.JPG', 2: '/images/gallary/skardu/front-skardu-8.png'
                }
            ],
            [
                {
                    1: '/images/gallary/skardu/back-skardu-9.JPG', 2: '/images/gallary/skardu/front-skardu-9.png'
                },
                {},
            ],
        ],
        map_track: 'https://www.google.com/maps/embed?pb=!1m50!1m12!1m3!1d1680719.7534603693!2d71.2935477330747!3d34.63813830733855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m35!3e0!4m5!1s0x38dfbfd07891722f%3A0x6059515c3bdb02b6!2sIslamabad%2C%20Islamabad%20Capital%20Territory%2C%20Pakistan!3m2!1d33.6844202!2d73.04788479999999!4m5!1s0x38d94b5c68b94dc7%3A0x25c8413211daa985!2sTakht%20Bhai%2C%20Mardan%2C%20Khyber%20Pakhtunkhwa%2C%20Pakistan!3m2!1d34.2875721!2d71.9342061!4m5!1s0x38dc22883054cb13%3A0x2f526c0fe9f65c9c!2sSaidu%20Sharif%2C%20Swat%2C%20Khyber%20Pakhtunkhwa%2C%20Pakistan!3m2!1d34.7492118!2d72.3562713!4m3!3m2!1d35.1079782!2d72.5112238!4m5!1s0x38dce4e4edd056a9%3A0x179ebb1f00409800!2sKalam%2C%20Swat%2C%20Khyber%20Pakhtunkhwa%2C%20Pakistan!3m2!1d35.4902022!2d72.5796331!4m5!1s0x38dcde49438c5ae1%3A0x44c292e0e612327f!2sMahodand%20Lake%2C%20Swat%2C%20Khyber%20Pakhtunkhwa%2C%20Pakistan!3m2!1d35.713923!2d72.6509652!5e0!3m2!1sen!2s!4v1664118383011!5m2!1sen!2sus'
    },
    {
        title: 'Swat & Kalam Valley',
        sub_title: 'Destination',
        details: 'Historically and religiously Swat Valley is considered to be a vital destination. Once, Swat was a major center of early Buddhism and a part of the Gandhara kingdom. Today, this locale is partially filled with the dissipated remnants and stupas from the past time, including Takh-e-Bahi - a Buddhist monastery, Butkara and some more. This place is not only historically significant but also due to its impeccable sceneries. We will traverse through some exceptional looking landscapes including Malam Jabba, Kalam, Miandam, Saidu Sharif and many more. Likewise, the traditional delicacies and the cultural heritage will make the entire visit a noteworthy visit. ',
        duration_d_n: ' 5 Days - 4 Nights',
        duration_d: ' 5 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-swat-cover.png',
        other_images: ['/images/tour_card/skardu1.png', '/images/tour_card/skardu2.png'],
        availability: 'Around the year',
        pickup: 'Islamabad Airport',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['4 Nights Hotel Accommodation on sharing basis', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Islamabad - Saidu Sharif',
            description: ['Pick up from designated place', 'Departure for Swat Valley via Malakand, Mardan and Batkhela', 'Visit White Palace and Islampur Village (Famous for handmade shawls', 'Arrived at hotel.', 'Overnight at the hotel in Swat. (Lunch & Dinner)']
        }, {
            arrow: 'Two',
            title: 'Saidu Sharif - Kalam',
            description: ['Breakfast will be served at Hotel', 'After breakfast drive to Kalam', 'On the way visit Khazakhela, Madyan and Bahrain', 'Arrive at Kalam and check to hotel', 'Overnight at hotel.', 'Overnight at the hotel in Kalam. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Three',
            title: 'Kalam',
            description: ['Mahodand Lake, Excursion.', 'Breakfast will be served at hotel', 'After breakfast visit Ushu Forest and Mahodand Lake on 4WD Jeeps.', 'Evening at leisure at the hotel.', 'Overnight at hotel.', 'Overnight at the hotel in Kalam. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Four',
            title: 'Kalam - Swat',
            description: ['Early breakfast will be served at hotel', 'After breakfast drive Swat via Malam Jabba visit.', 'Evening return to Swat.', 'Overnight at hotel.', 'Overnight at the hotel in Swat. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Five',
            title: 'Swat - Islamabad',
            description: ['Breakfast will be served at the hotel', 'Drive back to Islamabad', 'On the way, visit Takht e Bai (Buddhist Monastery)', 'Lunch will be provided on the way. Continue drive to Islamabad', 'After farewell dinner, drop to airport. (Breakfast, Lunch, Dinner)']
        }],
        gallery: [
            [true],
            [
                {
                    1: '/images/gallary/back-skardu-9.png', 2: '/images/gallary/pgs_8.png'
                },

                {
                    1: '/images/gallary/skardu-full-2.png', 2: '/images/gallary/front-skardu-2.png'
                }
            ],
            [
                {
                    1: '/images/gallary/skardu-full-3.png', 2: '/images/gallary/front-skardu-3.png'
                },
            ],
            [
                {
                    1: '/images/gallary/packageGallaryFullImg4.png', 2: '/images/gallary/pgl-3.png'
                },

                {
                    1: '/images/gallary/packageGallaryFullImg5.png', 2: '/images/gallary/pgl-4.png'
                }
            ],
            [
                {
                    1: '/images/gallary/packageGallaryFullImg6.png', 2: '/images/gallary/pgx-2.png'
                },
            ],
            [
                {
                    1: '/images/gallary/packageGallaryFullImg7.png', 2: '/images/gallary/pgl-5.png'
                },

                {
                    1: '/images/gallary/packageGallaryFullImg8.png', 2: '/images/gallary/pgl-6.png'
                }
            ],
            [
                {
                    1: '/images/gallary/packageGallaryFullImg9.png', 2: '/images/gallary/pgx-3.png'
                },
            ],
        ],
        map_track: ''
    },
    {
        title: 'Buddhist Trail',
        sub_title: 'Destination',
        details: 'ZoonSafari proudly organized a 14 member delegation comprising of senior Buddhist monks from Srilanka with the joint efforts of Prime Minister lmran Khan and High Commission of Pakistan Colombo to promote religious tourism in Pakistan. \n' + 'Pakistan is home to the ancient Buddhist civilization and several sacred relics and stupas were excavated here including the Fasting Buddha, Julian Monastery, Takht-e-Bahi, Taxila city, Shingardar & Dharma Rajika Stupa. \n' + 'Arriving in Lahore, the 2nd largest city of Pakistan provides an opportunity to explore and learn about its friendly people. It is known as the heart of the country, seat of learning with its numerous institutes and universities, center of culture with its enchanting old walled city, tantalizing food variety, Gardens, Mughal Gothic architecture and mausoleums of several Sufi Saints thronged by devotees around the year. An important city on the historic GT road connecting Kabul with Delhi, Lahore is witness to countless invasions, expeditions and trade caravarns. Dubbed as "the City of Gardens", Lahore features a relative abundance of green spaces scattered around the center and the leafy suburbs beyond, along with numerous Sufi Shrines and the Pakistan\'s greatest share of glorious Mughal monuments. Lahore\'s old city is a maze of bazaars, and the famous fort demonstrates the full pantheon of Mughal architecture, but there\'s also a modern side to the city. Known as the center of Buddhism and the Gandharan civilization. \n' + 'A journey to and through Swat Valley is without a doubt one of the most beautiful trips in the northern valleys of Pakistan, generously apportioned with lush forests, mountain vistas and a surprising array of largely Buddhist historical sites. Buddhist stupas are a common thing in Swat valley. While driving for Swat valley from Islamabad, about 35 km northwest, lies Taxila, one of the most important archeological sites in the whole of Asia. The origin of the site goes back to the Mesolithic age. Among all the Buddhist monasteries built through the length and breadth of Gandhara, Takht e Bahi is renowned as the most impressive and complete - and many would say the most beautiful. It is a UNESCO World Heritage Site, extraordinarily preserved and restored with a glorious location built along the Peshawar -Swat road. \n',
        duration_d_n: ' 8 Days - 7 Nights',
        duration_d: ' 8 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-buddhist-cover.png',
        other_images: ['/images/buddhist/front-buddhist-1.png', '/images/buddhist/front-buddhist-2.png'],
        availability: 'Around the year',
        pickup: 'Lahore Airport',
        departure: 'Lahore',
        return_: 'Lahore',
        included: ['7 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Lahore - Islamabad',
            description: ['Arrive Lahore in the morning and drive to Islamabad.', 'Lunch at local Restaurant.', 'Arrive in Islamabad & check in to hotel.', 'Dinner & Overnight at hotel']
        }, {
            arrow: 'Two',
            title: 'Islamabad - Taxila - Islamabad',
            description: ["Breakfast at hotel's restaurant.", "Proceed for full day excursion of Taxila City.", "Site contains remain of Buddhist era.", "Visit Julian monastery, City of Sirkap, Bhamala Stupa and Dharma Rajika Stupa.", "Lunch will be at a local restaurant.", "Later on, visit Taxila archaeological museum.", "Drive back to hotel for dinner and Overnight at hotel in Islamabad"]
        }, {
            arrow: 'Three',
            title: 'Islamabad - Swat',
            description: ["Breakfast at hotel's restaurant.", "Drive to Swat with visit of the remains of Takht e Bhai Buddhist Monastery from the Indo-Parthian period declared as World Heritage Site by UNESCO & Ashoka's rock carved edicts at Shahbaz Garhi.", "Lunch will be at a local restaurant.", "Also visit Barikot, Shingardar stupa stone carved Buddha at Ghalagai.", "Arrive Swat and transfer to the hotel,", "later on, visit Swat Museum. Dinner and overnight at hotel in Swat"]
        }, {
            arrow: 'Four',
            title: 'Swat',
            description: ["Breakfast at hotel's restaurant.", "Sightseeing in Swat includes visit of remains of monasteries of Butkara I and II, Saidu Stupa and Rock Carved Budha at Jehanabad.", "PM visit Mingora Bazar known for Swati Woolen Shawls, colorful tapestries, Gem stones and hand-woven carpets.", "Dinner & Overnight at hotel in Swat"]
        }, {
            arrow: 'Five',
            title: 'Swat - Lahore',
            description: ["Breakfast at hotel's restaurant.", "Return drive to Lahore. Lunch will be at a local restaurant.", "Arrive Lahore & check in to hotel. Dinner & Overnight at hotel in Lahore"]
        },
            {
                arrow: 'Six',
                title: 'Lahore',
                description: ["Breakfast at hotel's restaurant.", "Sightseeing in Lahore includes, Mughal era's Badshahi Mosque, Mughal's Fort of Lahore & Lahore Museum.", "Lunch will be at a local restaurant.", "Later on, visit Wagah Flag, Indo-Pak border for Flag ceremony.", "Dinner & Overnight at hotel in Lahore"]
            },
            {
                arrow: 'Seven',
                title: 'Lahore',
                description: ["Breakfast at hotel's restaurant.", "Visit Lahore's local markets.", "Lunch will be at a local restaurant.", "Dinner & Overnight at hotel in Lahore"]
            }, {
                arrow: 'Eight',
                title: 'Lahore',
                description: ['Transfer to airport for homebound flight', 'End of services']
            }],
        gallery: [
            [
                {
                    1: '/images/buddhist/back-buddhist-1.jpg', 2: '/images/buddhist/front-buddhist-1.png'
                },

                {
                    1: '/images/buddhist/back-buddhist-2.jpg', 2: '/images/buddhist/front-buddhist-2.png'
                }
            ],
            [
                {
                    1: '/images/buddhist/back-buddhist-5.jpg', 2: '/images/buddhist/front-buddhist-5.png'
                },
            ],
            [
                {
                    1: '/images/buddhist/back-buddhist-3.jpg', 2: '/images/buddhist/front-buddhist-3.png'
                },

                {
                    1: '/images/buddhist/back-buddhist-4.jpg', 2: '/images/buddhist/front-buddhist-4.png'
                }
            ],
            [
                {
                    1: '/images/buddhist/back-buddhist-6.jpg', 2: '/images/buddhist/front-buddhist-6.png'
                },
            ],
        ],
        map_track: ''
    },
    {
        title: 'Mughals & Gandhara _ A cultural & historical journey',
        sub_title: 'Destination',
        details: 'The Mughal Empire was one of the most dominant the world had ever observed. Its rulers made\n' +
            'eminent show-stoppers and joined the subcontinent as at no other time. Among the celebrated\n' +
            'Mughal architecture in Pakistan are the famous Badshahi Mosque, Lahore Fort, Wazir Khan Mosque,\n' +
            'Tomb of Jahangir and that\'s only the tip of the iceberg. Next, you will get an opportunity to contemplate\n' +
            'upon the patriots during the Wagha border ceremony, Pakistan and India border. In the midst of this\n' +
            'visit, plenty of Buddhist stupas can be seen from the old Gandhara civilization including Saidu stupa,\n' +
            'Amluk Dara Stupa, Tokar Dara Stupa, Gambatuna stupa and some more. To be sure this visit portrays\n' +
            'the genuine culture and heritage of Pakistan.',
        duration_d_n: ' 9 Days - 8 Nights',
        duration_d: ' 9 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-mughal-gandhara-cover.png',
        other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: 'Around the year',
        pickup: 'Airport',
        departure: 'Lahore to Islamabad',
        return_: 'Lahore',
        included: ['8 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Lahore',
            description: ['Arrive at Lahore Airport', 'Meet up with tour coordinator', 'Transfer to hotel', 'Overnight at hotel in Lahore']
        }, {
            arrow: 'Two',
            title: 'Lahore City Tour',
            description: ['Breakfast will be served at hotel', 'After breakfast visit Badshahi Mosque, Minar E Pakistan and Lahore Fort', 'Lunch will be served at local restaurant', 'After lunch visit Lahore Museum and Wazir Khan Mosque', 'Drive back to hotel', 'Dinner and overnight at hotel in Lahore']
        }, {
            arrow: 'Three',
            title: 'Shalimar Garden - Jhangir Tomb - Wagha Border ',
            description: ['Breakfast will be served at hotel', 'After breakfast visit Shalimar Garden and Jhangir Tomb', 'Lunch will be served at local restaurant', 'After lunch witness the flag ceremony at Wagha Border', 'Drive back to hotel', 'Dinner and overnight at hotel in Lahore']
        }, {
            arrow: 'Four',
            title: 'Hiran Minar - Salt Mines - Islamabad',
            description: ['Early breakfast will be served at hotel', 'After breakfast visit Hiran Minar', 'Drive to Islamabad', 'En route visit Salt Mines', 'Lunch will be served at local restaurant', 'Continue drive to Islamabad', 'Arrive at Islamabad', 'Dinner and overnight at hotel in Islamabad']
        }, {
            arrow: 'Five',
            title: 'Islamabad - Swat Museum - White Palace',
            description: ['Breakfast will be served at hotel', 'After breakfast drive to Swat', 'En route Swat Museum', 'Lunch will be served at local restaurant', 'Later on visit White Palace', 'Drive to hotel', 'Dinner and overnight at hotel in Swat']
        }, {
            arrow: 'Six',
            title: 'Jehanabad Buddha - Butkara 1 & 2 - Saidu Sharif',
            description: ['Breakfast will be served at hotel', 'After breakfast Jehanabad Buddha', 'Lunch will be served at local restaurant', 'After lunch visit Butkara 1 and 2', 'Drive back to hotel', 'En route visit Saidu Stupa', 'Arrive at hotel', 'Dinner and overnight at hotel in Swat']
        }, {
            arrow: 'Seven',
            title: 'Amluk Dara Stupa - Tokar Dara Stupa - Nimogram - Gumbatuns Stupa',
            description: ['Breakfast will be served at hotel', 'After breakfast Amluk Dara Stupa and Tokar Dara Stupa', 'Lunch will be served at local restaurant', 'Later on visit Nimogram and Gambatuna Stupa', 'Drive back to hotel', 'Dinner and overnight at hotel in Swat']
        }, {
            arrow: 'Eight',
            title: 'Ghalegai Buddha - Shangardar Stupa - Barikot - Takht e Bahi',
            description: ['Breakfast will be served at hotel', 'After breakfast visit Ghalegai Buddha, Shangardar Stupa and Gambat Balo Stupa', 'Lunch will be served at local restaurant', 'After lunch drive to Islamabad', 'En route visit Takht E Bahi', 'Continue drive to Islamabad', 'Arrive at Islamabad', 'Dinner and overnight at hotel in Islamabad']
        }, {
            arrow: 'Nine',
            title: 'Islamabad - Taxila Museum - Sirkup - Jullian - Airport Drop',
            description: ['Breakfast will be served at hotel', 'After breakfast drive to Taxila', 'Visit Taxila Museum, Sirkup and Jaulian Monastery (UNESCO World Heritage Site)', 'Lunch will be served at local restaurant', 'Continue drive to Islamabad', 'Arrive at Islamabad', 'Farewell dinner', 'Drive to Islamabad Airport']
        }
        ],
        gallery: [
            [],
            [],
        ],
        map_track: ''
    },
    {
        title: 'Exquisite Naran & Shogran Tour',
        sub_title: 'Destination',
        details: 'Pakistan is home to some heavenly and charming valleys. One of them is the Kaghan Valley, located in the Khyber Pakhtunkhwa province of Pakistan. The valley is stacked with some picturesque lakes; the well-known Saif UI Malook lake and Lulusar Lake are one of the main attractions of this visit. Naran is the focal point of Kaghan Valley located on the upper side of Kaghan valley, where the Kunhar river streams; the trout fish is an acclaimed delicacy of this place. The valley is surrounded by dense forest and the nature lovers who want to enjoy the serene and calm atmosphere should experience this valley for once in their lifetime.',
        duration_d_n: '5 Days - 4 Nights',
        duration_d: '5 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-naran-shogran-cover.png',
        other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: 'May - October',
        pickup: 'Airport',
        departure: '',
        return_: '',
        included: ['All transportation in destination location', '4 Nights Hotel Accommodation on sharing basis', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Islamabad - Shogran',
            description: ['Pick up from Airport and drive to Shogran ', ' On the way stop at Balakot Riverside for lunch break. ', ' Continue drive to Shogran. Arrive and transfer to your hotel. ', ' Overnight at Hotel in Shogran. (Lunch & Dinner)']
        }, {
            arrow: 'Two',
            title: 'Shogran - Sri Paye - Naran',
            description: ['Breakfast at hotel. ', ' AM. Drive to Sid Paya on 4wd Willy Jeeps ', ' Free time to explore surroundings of Sid Paya by walk. ', ' Return to the hotel in Shogran. ', ' PM. Drive to Naran. ', ' Arrive and transfer to your hotel in Naran. ', ' Overnight at hotel in Naran. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Three',
            title: 'Naran',
            description: ['Saif-ul-Maluk Excursion, ', ' Breakfast at hotel. ', ' After Breakfast day excursion to Saiful Muluk Lake by 4wd Willy Jeeps ', ' PM. Free time. ', ' Overnight at hotel in Naran. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Four',
            title: 'Naran',
            description: ['Lulusar Lake, Babusar Pass Excursion, ', ' Breakfast at hotel. ', ' After Breakfast day excursion to Lulusar Lake & Babusar Pass ', ' Afternoon. Free time. ', ' Overnight at hotel in Naran. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Five',
            title: 'Naran - Islamabad',
            description: ['Breakfast at hotel. ', ' After Breakfast drive back to Islamabad. ', ' Lunch will be served on the way. ', ' After farewell dinner, drop to the airport. (Breakfast, Lunch, Dinner)']
        }
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'HUNZA Valley in Autumn',
        sub_title: 'Destination',
        details: 'Autumn of Northern Pakistan is considered to be amongst the best of the world. Hunza is the place where you can\n' +
            'witness Pakistan in golden shades. Shades of the leaves from red to green from orange to red wraps you. Blue\n' +
            'green water streams make an astounding impact with the vibrant colors of autumn. During this trip, we will drive\n' +
            'through the magnificent Karakoram Highway and you will get a chance to ponder upon the gigantic Ultar, Hunza\n' +
            'Dome, Spantik and Diran, famous peaks surrounding Karimabad, while Rakaposhi at 7788m dominates the whole\n' +
            'panorama.',
        duration_d_n: '7 Days - 6 Nights',
        duration_d: ' 7 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-hunza-in-autumn-cover.png',
        other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: 'August - November',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['6 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Islamabad - Besham',
            description: ['Arrive in Islamabad', 'Drive through Abbottabad, Mansehra onward KKH', 'Arrive at Behsham', 'Check In to Hotel', 'Overnight at the hotel in Besham. (Lunch & Dinner)']
        }, {
            arrow: 'Two',
            title: 'Besham - Karimabad',
            description: ['Early breakfast will be served at hotel', 'After breakfast drive towards Karimabad (Hunza)', 'While on drive we make a few photo stops at Thalechi with Nanga', 'Parbat viewpoint offering breathtaking views of snow covered massif', 'The next stop will be at the Unique Point where three mountain ranges, Karakoram, Himalayas and Hindu Kush meet, near the confluence of Indus and Gilgit Rivers', 'Arrive at Karimabad and transfer to hotel', 'Overnight stay at the hotel in Karimabad. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Three',
            title: 'Karimabad',
            description: ['Full-Day Tour', 'Breakfast will be served at the hotel', 'After breakfast visits Baltit Fort (Baltit Fort is an ancient fort in the Hunza valley in Gilgit Baltistan, Pakistan. The foundations of the fort date back to 700 years ago, with rebuilds and alterations over the centuries. The architectural style is a clear indication of Buddhist Tibetan influence in Baltistan at the time) and Altit village and Fort (Altit Fort is situated in the village of Altit, about 3 km from Karimabad. It has been built on a sheer rock-cliff that falls 300 meters (1000 feet) into the Hunza River, and is much older than the Baltit Fort i.e 900 years old)', 'Free time will be given in Karimabad Bazar(shopping time in market for handicraft, gemstones, dry-fruits, fruit-products etc)', 'Overnight stay at the hotel in Karimabad. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Four',
            title: 'Karimabad - Gilgit',
            description: ['After breakfast visit Hopper Glacier (Hopper Glacier is said to be the fastest moving glacier on the planet and secondly it has a unique attribute of not being blanket white and clear like other glaciers) OPTIONAL EXCURSION', 'Drive to Attabad Lake (The lake was formed due to massive landslide at Attabad village in Gilgit-Baltistan, 9 miles (14 km) upstream (east) of Karimabad that occurred on January 4, 2010). Later on, drive to Gilgit', 'Upon arrival at Gilgit, visit Kargha Buddha and Gilgit Bazar', 'Overnight at the hotel in Gilgit. (Breakfast, Lunch & Dinner)',]
        }, {
            arrow: 'Five',
            title: 'Gilgit - Besham',
            description: ['Breakfast will be served at the hotel.', 'Drive through Chilas onward KKH', 'Arrive at Besham', 'Check In to Hotel', 'Overnight at the hotel in Besham. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Six',
            title: 'Besham - Islamabad',
            description: ['Breakfast will be served at hotel', 'Drive towards Islamabad via Batgram, Mansehra, Abbottabad.', 'Arrive at Islamabad. (Breakfast, Lunch)']
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'CHITRAL - HUNZA',
        sub_title: 'Destination',
        details: 'Amid this journey, you will get a chance to witness the concealed excellence of Chitral located in the Khyber-\n' +
            'Pakhtunkhwa province of Pakistan. Packed with 40 peaks above 6000m including the enormous Tirich Mir 7726m—\n' +
            'the highest peak of the Hindu Kush, you will surely enjoy the scenery. Kalasha valleys are inhabited by the Kalash\n' +
            'people, also called Waigali or Wai and as "Kafirs" are a Dardic Indo-Aryan indigenous people. They also claim to be\n' +
            'the descendants of Alexander the great. The alluring attraction of this region is the Chilam Joshi festival. This\n' +
            'festival is solely celebrated to welcome the spring season after the harsh winters; the valley becomes lively. These\n' +
            'people pray for the well-being of the valley including their livestock and pastures. Love and affection transcend\n' +
            'through the valley while the people here are enchanting, dancing and welcoming the peaceful nature of spring.',
        duration_d_n: '6 Days - 5 Nights',
        duration_d: '6 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-chitral-hunza-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: 'April -October',
        pickup: 'Airport',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['5 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Islamabad - Dir - Ayun',
            description: ['Morning drive from Islamabad to Dir.', 'On the way have your lunch in a suitable place.', 'Continue traveling to Ayun.', 'Arrive and transfer to your hotel.', 'Overnight at the hotel in Ayun. (Lunch & Dinner)']
        }, {
            arrow: 'Two',
            title: 'Ayun - Bamboret Kalash Valley',
            description: ['Breakfast at the hotel.', 'Transfer to Bamboret Kalash Valley by 4WD Jeeps.', 'Arrive and visit Bamboret & Rambur Valley.', 'Overnight at the hotel in Bamboret. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Three',
            title: 'Bamboret - Birir Valley - Chitral',
            description: ['Breakfast at the hotel.', 'Check out and drive to Birir Valley visit.', 'Then after proceed to Chitral Valley.', 'Arrive and transfer to your hotel in Chitral.', 'Overnight at the hotel in Chitral. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Four',
            title: 'Chitral',
            description: ['Garam Chashma, Excursion', 'After breakfast drive to Garam Chashma (Hot Spring).', 'Enjoy the area by visiting hot spring in the area.', 'Lunch in a suitable place in Garam Chashma.', 'Evening return to Chitral.', 'Overnight at the hotel in Chitral. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Five',
            title: 'Chitral - Dir - Swat Valley',
            description: ['Breakfast at the hotel.', 'Morning checkout and rive back to Swat via Dir.', 'On the way lunch in a suitable place.', 'Continue your traveling to Swat.', 'Arrive and transfer to your hotel in Swat.', 'Overnight at the hotel in Swat. (Breakfast, Lunch & Dinner)']
        }, {
            arrow: 'Six',
            title: 'Swat Valley - Islamabad',
            description: ['Breakfast will be served at the hotel', 'Drive towards Islamabad via Takht — e — Bhai monastery.', 'Evening drive to Islamabad.', 'Arrive at Islamabad.', 'After Farewell dinner, Transfer to Airport (Breakfast, Lunch, Dinner)', 'END OF TOUR']
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'HUNZA - Swat Valley',
        sub_title: 'Destination',
        details: 'Autumn of Northern Pakistan is considered to be amongst the best of the world. Hunza is the place where you can\n' +
            'witness Pakistan in golden shades. Shades of the leaves from red to green from orange to red wraps you. Blue\n' +
            'green water streams make an astounding impact with the vibrant colors of autumn. During this trip, we will drive\n' +
            'through the magnificent Karakoram Highway and you will get a chance to ponder upon the gigantic Ultar, Hunza\n' +
            'Dome, Spantik and Diran, famous peaks surrounding Karimabad, while Rakaposhi at 7788m dominates the whole\n' +
            'panorama.',
        duration_d_n: '15 Days - 14 Nights',
        duration_d: ' 15 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-hunza-swat-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Lahore',
        departure: 'Lahore',
        return_: 'Islamabad',
        included: ['14 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Lahore',
            description: []
        }, {
            arrow: 'Two',
            title: 'Lahore CSS',
            description: []
        }, {
            arrow: 'Three',
            title: 'Lahore CSS',
            description: []
        }, {
            arrow: 'Four',
            title: 'Lahore - Islamabad',
            description: []
        }, {
            arrow: 'Five',
            title: 'Islamabad - Naran',
            description: []
        }, {
            arrow: 'Six',
            title: 'Naran - Gilgit',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Gilgit - CSS',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Gilgit - Hunza',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Hunza CSS',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Hunza - Chilas',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Chilas - Swat',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Swat CSS',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Swat - Islamabad',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Islamabad CSS',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'North Pakistan',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '16 Days - 15 Nights',
        duration_d: ' 16 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-north-pakistan-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['15 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Naran',
            description: []
        }, {
            arrow: 'Three',
            title: 'Naran - Chilas',
            description: []
        }, {
            arrow: 'Four',
            title: 'Fairy Meadows',
            description: []
        }, {
            arrow: 'Five',
            title: 'Beyal Camp Trek',
            description: []
        }, {
            arrow: 'Six',
            title: 'FM - Gilgit',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Gilgit - Minapin',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Minapin - Hapakun',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Hapakun Tagafri',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Tagafri - Katcheli',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Tagafri - Hunza',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Hunza CSS',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Khunjerab Pass',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Hunza - Naran',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Naran - Islamabad',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Chitral - HUNZA',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '14 Days - 13 Nights',
        duration_d: ' 14 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-chitral-hunza-cover1.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['13 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Swat',
            description: []
        }, {
            arrow: 'Three',
            title: 'Swat - Chitral',
            description: []
        }, {
            arrow: 'Four',
            title: 'Excursion - Kalash',
            description: []
        }, {
            arrow: 'Five',
            title: 'Excursion - Kalash',
            description: []
        }, {
            arrow: 'Six',
            title: 'Chitral - Swat',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Swat - Besham',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Besham - Gilgit',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Gilgit CSS',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Gilgit - Hunza',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Khunjerab Pass',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Hunza - Chilas',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Chitral - Abbottabad',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Islamabad Departure',
            description: []
        }
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Gilgit Baltistan',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '16 Days - 15 Nights',
        duration_d: ' 16 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-gilgit-baltistan-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Lahore',
        departure: 'Lahore',
        return_: 'Islamabad',
        included: ['15 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Lahore',
            description: []
        }, {
            arrow: 'Two',
            title: 'Lahore CSS',
            description: []
        }, {
            arrow: 'Three',
            title: 'Lahore CSS',
            description: []
        }, {
            arrow: 'Four',
            title: 'Lahore - Abbottabad',
            description: []
        }, {
            arrow: 'Five',
            title: 'Naran / Besham',
            description: []
        }, {
            arrow: 'Six',
            title: 'Chilas',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Chilas - Hunza',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Hunza CSS',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Hunza CSS',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Hunza - Gilgit',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Gilgit - Shigar',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Shigar - Khaplu',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Shigar - Chilas',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Naran / Behsham',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Islamabad',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Shimshal Pass',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '14 Days - 13 Nights',
        duration_d: ' 14 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-shimshal-pass-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['13 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Naran',
            description: []
        }, {
            arrow: 'Three',
            title: 'Naran - Gulmit',
            description: []
        }, {
            arrow: 'Four',
            title: 'Gulmit - Shimshal',
            description: []
        }, {
            arrow: 'Five',
            title: 'Shimshal - Pasthfurzin',
            description: []
        }, {
            arrow: 'Six',
            title: 'Terk to Arbab Purin',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Terk to Shujarab',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Shimshal - Pass',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Manglik Sar',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Shimshal Pass',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Arbab Purin',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Pasthfurzin',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Shimshal Valley',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Drive - Gilgit',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Gilgit - Islamabad',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Biafo Hisper',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '20 Days - 19 Nights',
        duration_d: ' 20 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-biafo-hisper-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['19 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Skardu',
            description: []
        }, {
            arrow: 'Three',
            title: 'Skardu CSS',
            description: []
        }, {
            arrow: 'Four',
            title: 'Skardu - Askole',
            description: []
        }, {
            arrow: 'Five',
            title: 'Namla',
            description: []
        }, {
            arrow: 'Six',
            title: 'Mango',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Biantha',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Biantha',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Marfogoro',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Karphogoro',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Hisper La BC',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Hisper Snow Lake',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Khani Basa',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Bakhtur Beg',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Shiqam Baris',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Bitanmal',
            description: []
        }, {
            arrow: 'Seventeen',
            title: 'Hisper Village',
            description: []
        }, {
            arrow: 'Eighteen',
            title: 'Karimabad - Gilgit',
            description: []
        }, {
            arrow: 'Nineteen',
            title: 'Gilgit - Islamabad',
            description: []
        }, {
            arrow: 'twenty',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Gondogoro la pass',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '21 Days - 20 Nights',
        duration_d: ' 16 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-gondogoro-la-pass-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['20 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Skardu',
            description: []
        }, {
            arrow: 'Three',
            title: 'Skardu CSS',
            description: []
        }, {
            arrow: 'Four',
            title: 'Skardu - Askole',
            description: []
        }, {
            arrow: 'Five',
            title: 'Askole - Julah',
            description: []
        }, {
            arrow: 'Six',
            title: 'Julah - Paiyu',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Paiyu',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Paiyu - Khoburtse',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Khoburtse - Urdukas',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Urdukas - Goro',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Goro - Concordia',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Excursion to K2 OR Board Peak BC',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Concordia - Ali Camp',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Ali Camp - Khuspang',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Khuspang - Daltsompa',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Daltsompa - Shaishcho',
            description: []
        }, {
            arrow: 'Seventeen',
            title: 'Shaishcho - Hushe',
            description: []
        }, {
            arrow: 'Eighteen',
            title: 'Skardu CSS',
            description: []
        }, {
            arrow: 'Nineteen',
            title: 'Skardu - Chilas',
            description: []
        }, {
            arrow: 'Twenty',
            title: 'Chilas - Islamabad',
            description: []
        }, {
            arrow: 'TwentyOne',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Patundas - Rushlake',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '17 Days - 16 Nights',
        duration_d: ' 16 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-patundas-rushlake-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Islamabad',
        departure: 'Islamabad',
        return_: 'Islamabad',
        included: ['16 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Arrive Islamabad',
            description: []
        }, {
            arrow: 'Two',
            title: 'Islamabad - Naran',
            description: []
        }, {
            arrow: 'Three',
            title: 'Borit Lake',
            description: []
        }, {
            arrow: 'Four',
            title: 'Luzdhar',
            description: []
        }, {
            arrow: 'Five',
            title: 'Patundas',
            description: []
        }, {
            arrow: 'Six',
            title: 'Patundas Day Free',
            description: []
        }, {
            arrow: 'Seven',
            title: 'Passu',
            description: []
        }, {
            arrow: 'Eight',
            title: 'Hoper',
            description: []
        }, {
            arrow: 'Nine',
            title: 'Baricho Khor',
            description: []
        }, {
            arrow: 'Ten',
            title: 'Chidin Hara',
            description: []
        }, {
            arrow: 'Eleven',
            title: 'Rush Peak & Lake',
            description: []
        }, {
            arrow: 'Twelve',
            title: 'Hamdar',
            description: []
        }, {
            arrow: 'thirteen',
            title: 'Hoper - Hunza',
            description: []
        }, {
            arrow: 'Fourteen',
            title: 'Khunjerab Pass',
            description: []
        }, {
            arrow: 'Fifteen',
            title: 'Hunza CSS - Gilgit',
            description: []
        }, {
            arrow: 'Sixteen',
            title: 'Gilgit - Islamabad',
            description: []
        }, {
            arrow: 'Seventeen',
            title: 'Departure',
            description: []
        },
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Baluchistan',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '9 Days - 8 Nights',
        duration_d: ' 9 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/tour_cover/tour-baluchistan-cover.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Karachi',
        departure: 'Karachi',
        return_: 'Islamabad Karachi',
        included: ['8 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Bangkok - Karachi',
            description: ['Arrive Karachi by TG  at 0000 hrs. Meet & transfer to Hotel.', 'Overnight at – Karachi', 'No meals']
        }, {
            arrow: 'Two',
            title: 'Karachi – Mohenjo Daro',
            description: ['Drive to Mohenjodaro. Upon arrival visit Mohenjodaro', 'Enjoy sunset at Mohenjo-Daro.', 'Overnight at Rest House – Mohenjodaro', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Three',
            title: 'Mohenjo Daro – Gorakh Hill',
            description: ['AM: Sightseeing of Mohenjodaro.', 'Drive to Gorakh Hill Station. Visit Gorakh Hill Station', 'Overnight at Guest House – Gorakh Hill Station', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Four',
            title: 'Gorakh Hill - Hyderabad',
            description: ['Drive to Hyderabad', 'Upon arrival transfer to the hotel', 'Overnight at hotel – Hyderabad', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Five',
            title: 'Hyderabad - Kund Malir',
            description: ['Drive to Kund Malir.', 'Evening visit Chandragup Mud Volcano.', 'Overnight at Camp – Kund Malir', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Six',
            title: 'Pachari & Hingol National Park',
            description: ['AM: Half day excursion to Pachari', 'PM: Hingol National Park (Temple & Ibex)', 'Overnight at Camp – Kund Malir', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Seven',
            title: 'Kund Malir - Ormara - Pasni',
            description: ['Drive to Pasni with visit of Ormara,', 'later visit Pasni sand dunes.', 'Overnight at Hotel – Pasni', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Eight',
            title: 'Excursion to Gwadar & Jiwani',
            description: ['After breakfast, proceed for a full day excursion to Gwadar, and enjoy the sunset at Jiwani known as the last corner of Pakistan', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Nine',
            title: 'Pasni   - Karachi - Bangkok',
            description: ['After breakfast drive to Karachi, upon arrival have an early dinner later transfer to airport for home bound flight.', 'Breakfast, Lunch & Dinner', 'End of tour services']
        }
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
    {
        title: 'Lahore',
        sub_title: 'Destination',
        details: '',
        duration_d_n: '9 Days - 8 Nights',
        duration_d: ' 9 Days',
        tour_type: '____',
        group_size: '____',
        tour_guide: '05 People',
        cover_image: '/images/destination/p_destination_lahore.png',
        // other_images: ['/images/p_370x267.png', '/images/p_370x267.png'],
        availability: '___',
        pickup: 'Karachi',
        departure: 'Karachi',
        return_: 'Islamabad Karachi',
        included: ['8 Nights Hotel Accommodation', 'All transportation in destination location', 'All meals as per itinerary', 'Tour Guide', 'Entrance Fees'],
        excluded: ['Guide Service Fee', 'Driver Service Fee', 'Any Private Expense', 'Room Service Fees'],
        travel_by: {vehicle: 'Travel With Bus', icon: '/images/icons/bus.svg'},
        itinerary: [{
            arrow: 'One',
            title: 'Bangkok - Karachi',
            description: ['Arrive Karachi by TG  at 0000 hrs. Meet & transfer to Hotel.', 'Overnight at – Karachi', 'No meals']
        }, {
            arrow: 'Two',
            title: 'Karachi – Mohenjo Daro',
            description: ['Drive to Mohenjodaro. Upon arrival visit Mohenjodaro', 'Enjoy sunset at Mohenjo-Daro.', 'Overnight at Rest House – Mohenjodaro', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Three',
            title: 'Mohenjo Daro – Gorakh Hill',
            description: ['AM: Sightseeing of Mohenjodaro.', 'Drive to Gorakh Hill Station. Visit Gorakh Hill Station', 'Overnight at Guest House – Gorakh Hill Station', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Four',
            title: 'Gorakh Hill - Hyderabad',
            description: ['Drive to Hyderabad', 'Upon arrival transfer to the hotel', 'Overnight at hotel – Hyderabad', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Five',
            title: 'Hyderabad - Kund Malir',
            description: ['Drive to Kund Malir.', 'Evening visit Chandragup Mud Volcano.', 'Overnight at Camp – Kund Malir', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Six',
            title: 'Pachari & Hingol National Park',
            description: ['AM: Half day excursion to Pachari', 'PM: Hingol National Park (Temple & Ibex)', 'Overnight at Camp – Kund Malir', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Seven',
            title: 'Kund Malir - Ormara - Pasni',
            description: ['Drive to Pasni with visit of Ormara,', 'later visit Pasni sand dunes.', 'Overnight at Hotel – Pasni', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Eight',
            title: 'Excursion to Gwadar & Jiwani',
            description: ['After breakfast, proceed for a full day excursion to Gwadar, and enjoy the sunset at Jiwani known as the last corner of Pakistan', 'Breakfast, Lunch & Dinner']
        }, {
            arrow: 'Nine',
            title: 'Pasni   - Karachi - Bangkok',
            description: ['After breakfast drive to Karachi, upon arrival have an early dinner later transfer to airport for home bound flight.', 'Breakfast, Lunch & Dinner', 'End of tour services']
        }
        ],
        gallery: [
            [],
        ],
        map_track: ''
    },
]
export default tours_detail;





